<template>
  <div v-title data-title="卓考网校|精品课程免费试听">
    <header class="g-header-container">
      <c-header title="课程试听" />
    </header>
    <main class="g-view-container">
      <div class="video-player">
        <video v-if="playUrl" class="video" ref="video" controls autoplay>
          <source :src="playUrl" type="video/mp4" />
        </video>
      </div>
      <div class="video-list">
        <h2 class="title">视频列表</h2>
        <div class="list">
          <template v-for="(item, index) in playList">
            <van-cell
              :key="index"
              :title="item.name"
              icon="video"
              clickable
              @click="videoId = item.videoExcellentId"
              :class="item.videoExcellentId==videoId?'active':''"
            >
              <van-icon slot="right-icon" name="play-circle" style="line-height: inherit;" />
            </van-cell>
          </template>
        </div>
      </div>
    </main>
    <footer class="g-footer-container">
      <c-tabbar />
    </footer>
  </div>
</template>

<script>
  import courseModel from 'models/course';
  import CHeader from 'components/header';
  import CTabbar from 'components/tabbar';

  export default {
    name: 'Video',
    components: {
      CHeader,
      CTabbar,
    },
    data() {
      return {
        courseId: '', // 课程ID
        videoId: this.$route.params.videoId || 1, // 视频ID
        playUrl: '', // 正在播放的视频地址
        playList: [], // 播放列表
      };
    },
    watch: {
      videoId(val) {
        this.getVideoPlayUrl(val);
      },
      playUrl(val) {
        this.$refs.video.src = val;
      },
    },
    created() {
      this.getVideoPlayUrl(this.videoId);
    },
    methods: {
      getVideoPlayUrl(videoId) {
        const { playList } = this;
        if (playList.length) {
          for (let i = 0, { length } = playList; i < length; i += 1) {
            if (playList[i].videoExcellentId === videoId) {
              this.playUrl = playList[i].playUrl;
              return;
            }
          }
        } else {
          courseModel.getVideoInfo(videoId).then((res) => {
            if (res.data.code === 200) {
              this.professionId = res.data.data.professionId;
              this.courseId = res.data.data.courseId;
              this.playUrl = res.data.data.playUrl;
              this.getVideoPlayList(this.professionId, this.courseId);
            }
          });
        }
      },
      getVideoPlayList(pid, cid) {
        courseModel.getPlayList(pid).then((res) => {
          if (res.data.code === 200) {
            const videoList = res.data.data;
            for (let i = 0, { length } = videoList; i < length; i += 1) {
              if (videoList[i].courseId === cid) {
                this.playList = videoList[i].excellentList.slice(0, 5);
                break;
              }
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";
.video-player {
  width: 100%;
  min-height: 210px;

  .video {
    width: 100%;
  }
}
.video-list {
  .title {
    position: relative;
    padding: 0 15px;
    font-size: $font-size-l;
    color: #333;
    line-height: 40px;
    background-color: #fff;
    border-bottom: 1px solid #eee;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 84px;
      border-bottom: 3px solid #f9686d;
    }
  }
  .list {
    .active {
      color: $theme-color;
    }
  }
}
</style>
